import React from 'react';
import HeroSection2 from '../components/herosections/HeroSection2';
import TrustedBrands from '../components/home/TrustedBrands';
import AboutUs from '../components/home/AboutUs';
import Services from '../components/home/Services';
import Team from '../components/home/Team';
import FAQs from '../components/home/FAQs';
import Blog from '../components/home/Blog';

const Home2 = () => {
    return (
        <>
            <HeroSection2 />
            <TrustedBrands />
            <AboutUs />
            <Services />
            <Team />
            <Blog />
            <FAQs />
        </>
    )
}

export default Home2;
